import { Text, View } from '@react-pdf/renderer';
import { ICompanyInfo } from 'interfaces/store/companyInfo';
import { getPdfStatistics } from 'utils/helpers/mapPdfInfo';

export const Statistics = ({ companyInfo }: { companyInfo: ICompanyInfo }) => {
  const statistics = getPdfStatistics(companyInfo);

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: '20px'
      }}
    >
      {statistics.map(data => (
        <View
          key={data.label}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '2px',
            flex: 1,
            padding: '6px 12px',
            borderLeft: '2px solid #4DB96B'
          }}
        >
          <Text
            style={{
              fontSize: '14px',
              fontWeight: 'semibold',
              color: '#151515'
            }}
          >
            {data.value}
          </Text>

          <Text
            style={{
              fontSize: '10px',
              fontWeight: 'light',
              color: '#5C5C5C'
            }}
          >
            {data.label}
          </Text>
        </View>
      ))}
    </View>
  );
};
